var ProductPage = Barba.BaseView.extend({
    namespace: 'product-page',
    onEnter: function() {
        jQuery.ready()
        // The new Container is ready and attached to the DOM.
        // $('select').selectric();
        addToCartAjax();
        convertSelectricToRadio();
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
        jQuery.ready()



        let timeoutFunc;


        $('.wp-playlist').on('click', function(e){
            clearTimeout(timeoutFunc)

            timeoutFunc = setTimeout(function(){
                $('.mejs-mediaelement audio')[0].player.pause();
            }, 30000);

        })



    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
        $('html, body').animate({
            scrollTop: 0
        }, 10);

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.



    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!



